import { render, staticRenderFns } from "./SummaryPayment.vue?vue&type=template&id=1ef193e5"
import script from "./SummaryPayment.vue?vue&type=script&lang=ts"
export * from "./SummaryPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports